import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const NavigationButton = ({ icon, label, path, variant = 'primary', locked = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!locked) {
      navigate(path);
    }
  };

  const getVariantStyles = () => {
    if (locked) {
      return 'bg-muted border-muted-foreground/30 cursor-not-allowed opacity-50';
    }

    switch (variant) {
      case 'primary':
        return 'bg-primary/20 border-primary hover:bg-primary/30 shadow-glow-cyan-sm hover:shadow-glow-cyan-md';
      case 'secondary':
        return 'bg-secondary/20 border-secondary hover:bg-secondary/30 shadow-glow-magenta-sm hover:shadow-glow-magenta-md';
      case 'accent':
        return 'bg-accent/20 border-accent hover:bg-accent/30 shadow-glow-green-sm hover:shadow-glow-green-md';
      default:
        return 'bg-primary/20 border-primary hover:bg-primary/30 shadow-glow-cyan-sm hover:shadow-glow-cyan-md';
    }
  };

  const getIconColor = () => {
    if (locked) return 'var(--color-muted-foreground)';
    
    switch (variant) {
      case 'primary':
        return 'var(--color-primary)';
      case 'secondary':
        return 'var(--color-secondary)';
      case 'accent':
        return 'var(--color-accent)';
      default:
        return 'var(--color-primary)';
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={locked}
      className={`
        w-full min-h-[120px] md:min-h-[140px] lg:min-h-[160px]
        border-2 rounded-sm p-4 md:p-6 lg:p-8
        transition-all duration-base
        flex flex-col items-center justify-center gap-3 md:gap-4
        touch-target
        ${getVariantStyles()}
        ${!locked && 'hover:scale-105 active:scale-95'}
      `}
    >
      <div className="relative">
        <Icon name={icon} size={48} color={getIconColor()} />
        {locked && (
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-error rounded-sm flex items-center justify-center border border-error">
            <Icon name="Lock" size={14} color="var(--color-error-foreground)" />
          </div>
        )}
      </div>
      <span className={`
        text-base md:text-lg lg:text-xl font-heading font-bold tracking-wide
        ${locked ? 'text-muted-foreground' : 'neon-text-cyan'}
      `}>
        {label}
      </span>
    </button>
  );
};

export default NavigationButton;